const autoNgTemplateLoaderTemplate1 = require('./imagesDatatable.html');

angular.module('shbdeployer.docker').component('imagesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'ImagesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    showHostColumn: '<',
    removeAction: '<',
    downloadAction: '<',
    forceRemoveAction: '<',
    exportInProgress: '<',
    offlineMode: '<',
    refreshCallback: '<',
  },
});
